var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6257 0V12.8342H7.13013V6.41712H0V19.9644H13.5472V15.3298H19.9644V14.9733H20V0H9.6257Z",
    fill: "#9BA1B2",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6257 0V12.8342H7.13013V6.41712H0V19.9644H13.5472V15.3298H19.9644V14.9733H20V0H9.6257ZM0.713013 7.13013H3.20858V8.55616H3.92159V7.13013H6.41712V12.8342H0.713013V7.13013ZM6.41712 19.2514H0.713013V13.5472H3.20858V14.9733H3.92159V13.5472H6.41712V19.2514ZM12.8342 19.2514H7.13013V13.5472H9.6257V15.3298H12.8342V19.2514ZM19.287 14.6167H10.3387V0.713013H19.287V14.6167Z",
    fill: "#9BA1B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5384 2.85205H13.9038V3.56506H18.5384V2.85205Z",
    fill: "#9BA1B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5384 6.41711H13.9038V7.13013H18.5384V6.41711Z",
    fill: "#9BA1B2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7559 9.98218H13.9038V10.6952H16.7559V9.98218Z",
    fill: "#9BA1B2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.868 3.81787L12.1212 4.06739L12.3743 3.81787L12.5525 3.63959L13.8003 2.39183L13.2941 1.88559L12.1212 3.06206L11.6613 2.5986L11.155 3.10484L11.6898 3.63959L11.868 3.81787Z",
    fill: "#9BA1B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.868 7.38293L12.1212 7.63245L12.3743 7.38293L12.5525 7.20464L13.8003 5.9569L13.2941 5.45065L12.1212 6.62711L11.6613 6.16367L11.155 6.66992L11.6898 7.20464L11.868 7.38293Z",
    fill: "#9BA1B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.868 10.9479L12.1212 11.1975L12.3743 10.9479L12.5525 10.7697L13.8003 9.52192L13.2941 9.01572L12.1212 10.1922L11.6613 9.72868L11.155 10.2349L11.6898 10.7697L11.868 10.9479Z",
    fill: "#9BA1B2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu5);
export default __webpack_public_path__ + "static/media/menu-5.a83501b52ab8896bc7a3e792072a91fe.svg";
export { ForwardRef as ReactComponent };